import script from "./FormComponentsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./FormComponentsBlock.vue?vue&type=script&setup=true&lang=js"

import "./FormComponentsBlock.vue?vue&type=style&index=0&id=0ecf204c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecf204c"]])

export default __exports__